import React from 'react';
import { createPortal } from 'react-dom';

/*
 * Portalea el contenido a <body> para que el overlay `position: fixed` cubra
 * TODA la pantalla y quede centrado, sin quedar atrapado por el contenedor
 * de contenido (.admin-shell-main) ni por ancestros con transform/overflow.
 * Se envuelve en `.cartera-dash` para conservar los estilos scoped
 * (.btn, .tnum, .co-fade, .co-row-hover, tokens --pei-*).
 */
export const ModalPortal = ({ children }) => {
  if (typeof document === 'undefined') return null;
  return createPortal(<div className="cartera-dash">{children}</div>, document.body);
};

export default ModalPortal;
